<div class="billing-editor">
  <div class="header-section">
    <div class="header-info">
      <h3>Master Billing Editor
        <span *ngIf="hasPendingChanges" class="pending-changes-badge">
          <mat-icon color="warn">warning</mat-icon>
          {{ pendingChangesCount }} pending changes
        </span>
      </h3>
      <p>Filtered {{ filteredData.length }} billing records from {{ allData.length }} total records in the selected date
        range</p>
    </div>
    <div class="header-actions">

      <button mat-raised-button color="primary" (click)="saveAllPendingChanges()" [disabled]="isPersistingData"
        *ngIf="hasPendingChanges">
        <mat-spinner diameter="20" *ngIf="isPersistingData"></mat-spinner>
        <mat-icon *ngIf="!isPersistingData">save</mat-icon>
        {{ isPersistingData ? 'Saving...' : 'Save All Changes' }} ({{ pendingChangesCount }})
      </button>

      <button mat-stroked-button color="warn" (click)="discardAllPendingChanges()" [disabled]="isPersistingData"
        *ngIf="hasPendingChanges">
        <mat-icon>clear</mat-icon>
        Discard All Changes
      </button>
    </div>
  </div>

  <div class="patient-groups" *ngIf="groupedPatients.length > 0; else noData">
    <div *ngFor="let group of groupedPatients" class="patient-group">
      <!-- Patient Header - Always Visible -->
      <div class="patient-header" (click)="toggleExpansion('patient', group.patient.id)">
        <div class="patient-info">
          <mat-icon class="expand-icon">
            {{ isExpanded('patient', group.patient.id) ? 'expand_less' : 'expand_more' }}
          </mat-icon>
          <span class="patient-name">{{ group.patient.name }} {{ group.patient.surname }}</span>
          <span class="patient-number">({{ group.patient.patientNumber }})</span>
          <span class="record-count">[{{ group.totalRecords }} records]</span>
        </div>

        <div class="patient-actions">
          <button mat-icon-button (click)="createCode('patient', group.patient.id); $event.stopPropagation()"
            matTooltip="Add Code for Patient" class="add-code-button">
            <mat-icon>add</mat-icon>
          </button>
          <button mat-icon-button (click)="toggleAllSublevels(group.patient.id); $event.stopPropagation()"
            matTooltip="Expand/Collapse All Sublevels" class="bulk-expand-button">
            <mat-icon>{{ isExpanded('patient', group.patient.id) ? 'unfold_less' : 'unfold_more' }}</mat-icon>
          </button>
          <button mat-icon-button (click)="navigateToPatientFile(group.patient.id); $event.stopPropagation()"
            matTooltip="Open Patient File" class="patient-file-button">
            <mat-icon>visibility</mat-icon>
          </button>
        </div>
      </div>

      <!-- Expandable Date Groups -->
      <div *ngIf="isExpanded('patient', group.patient.id)" class="date-groups">
        <div *ngFor="let dateGroup of group.dateGroups" class="date-group">
          <!-- Date Header -->
          <div class="date-header" (click)="toggleExpansion('date', group.patient.id, dateGroup.dateKey)">
            <div class="date-info">
              <mat-icon class="expand-icon">
                {{ isExpanded('date', group.patient.id, dateGroup.dateKey) ? 'expand_less' : 'expand_more' }}
              </mat-icon>
              <span class="date-text">{{ dateGroup.date | date:'mediumDate' }}</span>
              <span class="record-count">[{{ dateGroup.count }} records]</span>
            </div>
            <div class="date-actions">
              <button mat-icon-button
                (click)="createCode('date', group.patient.id, dateGroup.date); $event.stopPropagation()"
                matTooltip="Add Code for Date" class="add-code-button">
                <mat-icon>add</mat-icon>
              </button>
              <button mat-icon-button
                (click)="toggleAllTimes(group.patient.id, dateGroup.dateKey); $event.stopPropagation()"
                matTooltip="Expand/Collapse All Times" class="bulk-expand-button">
                <mat-icon>{{ isExpanded('date', group.patient.id, dateGroup.dateKey) ? 'unfold_less' : 'unfold_more'
                  }}</mat-icon>
              </button>
            </div>
          </div>

          <!-- Expandable Time Groups -->
          <div *ngIf="isExpanded('date', group.patient.id, dateGroup.dateKey)" class="time-groups">
            <div *ngFor="let timeGroup of dateGroup.timeGroups" class="time-group">
              <!-- Time Header -->
              <div class="time-header"
                (click)="toggleExpansion('time', group.patient.id, dateGroup.dateKey, timeGroup.timeKey)">
                <div class="time-info">
                  <mat-icon class="expand-icon">
                    {{ isExpanded('time', group.patient.id, dateGroup.dateKey, timeGroup.timeKey) ? 'expand_less' :
                    'expand_more' }}
                  </mat-icon>
                  <span class="time-text">
                    {{ timeGroup.startTime && timeGroup.endTime ? (timeGroup.startTime + ' - ' + timeGroup.endTime) :
                    'No Time' }}
                  </span>
                  <span class="record-count">[{{ timeGroup.count }} records]</span>
                  <button mat-icon-button
                    (click)="editTimeGroup(group.patient.id, dateGroup.dateKey, timeGroup.timeKey, timeGroup.startTime, timeGroup.endTime); $event.stopPropagation()"
                    matTooltip="Edit time for all codes in this group" class="edit-time-button">
                    <mat-icon color="primary">edit</mat-icon>
                  </button>
                </div>
                <div class="time-actions">
                  <button mat-icon-button
                    (click)="createCode('time', group.patient.id, dateGroup.date, timeGroup.startTime, timeGroup.endTime); $event.stopPropagation()"
                    matTooltip="Add Code for Time" class="add-code-button">
                    <mat-icon>add</mat-icon>
                  </button>
                </div>
              </div>

              <!-- Provider Groups (Non-collapsible) -->
              <div *ngIf="isExpanded('time', group.patient.id, dateGroup.dateKey, timeGroup.timeKey)"
                class="provider-groups">
                <div *ngFor="let providerGroup of timeGroup.providerGroups" class="provider-group">
                  <!-- Provider Label -->
                  <div class="provider-label">
                    <span class="provider-name">{{ providerGroup.providerName }}</span>
                    <span class="record-count">[{{ providerGroup.count }} records]</span>
                    <button mat-icon-button
                      (click)="editProviderGroup(group.patient.id, dateGroup.dateKey, timeGroup.timeKey, providerGroup.providerId, providerGroup.providerName); $event.stopPropagation()"
                      matTooltip="Edit provider for all codes in this group" class="edit-provider-button">
                      <mat-icon color="primary">person</mat-icon>
                    </button>
                  </div>

                  <div class="procedure-code-selector-container">
                    <app-procedure-code-selector [initialCodes]="providerGroup.records"
                      [onChipDblClick]="openEditDialog.bind(this)" hintText="Double click or tap and hold to edit individual codes"
                      (codeDeleted)="onProcedureCodeDeleted($event, providerGroup.providerGroupKey)"
                      (codesChanged)="onExistingProcedureCodesChanged($event, providerGroup.providerGroupKey)"
                      [patient]="group.patient" [disableAdding]="true" [enableDragAndDrop]="true">
                    </app-procedure-code-selector>
                  </div>

                  <mat-divider></mat-divider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #noData>
    <div class="no-data">
      <p>No billing records found matching the current filters.</p>
    </div>
  </ng-template>
</div>

<!-- Create/Edit Code Dialog -->
<ng-template #addCodeDialog>
  <h1 mat-dialog-title>{{ editingCode.id ? 'Edit Code' : 'Add New Procedure Codes' }}</h1>
  <div mat-dialog-content>
    <div class="p-t-20 column-fields">
      <mat-form-field appearance="outline">
        <mat-label>Date</mat-label>
        <input matInput [matDatepicker]="dateDatePicker" [ngModel]="getCurrentDate()"
          (ngModelChange)="onDateChange($event)" placeholder="DD/MM/YYYY" required>
        <mat-datepicker-toggle matSuffix [for]="dateDatePicker"></mat-datepicker-toggle>
        <mat-datepicker #dateDatePicker></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Start Time</mat-label>
        <input matInput [ngModel]="getCurrentStartTime()" (ngModelChange)="onStartTimeChange($event)"
          [ngxTimepicker]="startTimePicker" [format]="24">
        <ngx-material-timepicker #startTimePicker [theme]="darkTheme" [appendToInput]="true"
          [preventOverlayClick]="true"></ngx-material-timepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>End Time</mat-label>
        <input matInput [ngModel]="getCurrentEndTime()" (ngModelChange)="onEndTimeChange($event)"
          [ngxTimepicker]="endTimePicker" [format]="24">
        <ngx-material-timepicker #endTimePicker [theme]="darkTheme" [appendToInput]="true"
          [preventOverlayClick]="true"></ngx-material-timepicker>
      </mat-form-field>

      <!-- Provider Selection Dropdown -->
      <mat-form-field appearance="outline">
        <mat-label>Provider</mat-label>
        <mat-select [ngModel]="getCurrentProviderId()" (selectionChange)="onProviderSelectionChange($event.value)">
          <mat-option *ngFor="let user of groupUsers" [value]="user.userId">
            {{user.title}} {{user.name}} {{user.surname}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <div class="toggle-container">
        <mat-slide-toggle [ngModel]="getCurrentPaidCash()" (ngModelChange)="onPaidCashChange($event)"
          color="primary">Paid Up Front</mat-slide-toggle>
        <mat-slide-toggle [ngModel]="getCurrentNoCharge()" (ngModelChange)="onNoChargeChange($event)" color="primary"
          class="m-l-5">Pro Bono</mat-slide-toggle>
      </div>

      <!-- Only show procedure code selector when creating new codes -->
      <app-procedure-code-selector *ngIf="!editingCode.id" [initialCodes]="selectedProcedureCodes"
        [onChipDblClick]="openEditDialog.bind(this)" hintText="Double click or tap and hold a specific code to edit it's details"
        (codesChanged)="onProcedureCodesChanged($event)" (codeDeleted)="onProcedureCodeDeleted($event)"
        [patient]="creatingCode.patient" #procedureCodeSelector>
      </app-procedure-code-selector>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="editingCode.id ? cancelEditCode() : cancelCreateCode()">Cancel</button>
    <button mat-raised-button color="primary" (click)="editingCode.id ? saveCodeEdit() : saveNewCode()">
      {{ editingCode.id ? 'Update' : 'Save' }}
    </button>
  </div>
</ng-template>

<!-- Edit Time Dialog -->
<ng-template #editTimeDialog>
  <h1 mat-dialog-title>Edit Times</h1>
  <div mat-dialog-content>
    <div class="p-t-20 column-fields">
      <p class="edit-time-description">
        This will update the start and end times for all billing codes in this time group.
      </p>

      <mat-form-field appearance="outline">
        <mat-label>Start Time</mat-label>
        <input matInput [(ngModel)]="editingTime.startTime" [ngxTimepicker]="editStartTimePicker" [format]="24">
        <ngx-material-timepicker #editStartTimePicker [theme]="darkTheme" [appendToInput]="true"
          [preventOverlayClick]="true"></ngx-material-timepicker>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>End Time</mat-label>
        <input matInput [(ngModel)]="editingTime.endTime" [ngxTimepicker]="editEndTimePicker" [format]="24">
        <ngx-material-timepicker #editEndTimePicker [theme]="darkTheme" [appendToInput]="true"
          [preventOverlayClick]="true"></ngx-material-timepicker>
      </mat-form-field>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="cancelTimeEdit()">Cancel</button>
    <button mat-raised-button color="primary" (click)="saveTimeEdit()">Update Time</button>
  </div>
</ng-template>

<!-- Edit Provider Dialog -->
<ng-template #editProviderDialog>
  <h1 mat-dialog-title>Edit Provider</h1>
  <div mat-dialog-content>
    <div class="p-t-20 column-fields">
      <p class="edit-provider-description">
        This will update the provider for all billing codes in this provider group.
      </p>

      <mat-form-field appearance="outline">
        <mat-label>Current Provider</mat-label>
        <input matInput [value]="editingProvider.providerName" readonly>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>New Provider</mat-label>
        <mat-select [ngModel]="editingProvider.newProviderId"
          (selectionChange)="onProviderEditSelectionChange($event.value)" required>
          <mat-option *ngFor="let user of groupUsers" [value]="user.userId">
            {{user.title}} {{user.name}} {{user.surname}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>

  <div mat-dialog-actions class="dialog-actions">
    <button mat-button (click)="cancelProviderEdit()">Cancel</button>
    <button mat-raised-button color="primary" (click)="saveProviderEdit()">Update Provider</button>
  </div>
</ng-template>